import * as React from 'react';
import RootState from 'src/modules/rootState';
import { selectors as WorkflowSelector } from 'src/modules/entities/workflow';
import { withRouter, RouteComponentProps, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch, AnyAction } from 'redux';
import Header from './components/Header';
import Indicator from './components/shared/Indicator';
import MainMenu from './components/MainMenu';
import Provider from './components/Provider';
import Experian from './components/Experian';
import ContractAgreement from './components/ContractAgreement';
import Payment from './components/Payment';
// import Attachment from './components/Attachment';
import Summary from './components/Summary';
import CompleteWithFailAllowedRetry from './components/General/CompleteWithFailAllowedRetry';
import CompleteWithPermanentFail from './components/General/CompleteWithPermanentFail';
import Error_UserExist from './components/General/Error_UserExist';
import Workflow from 'src/models/workflow';
import { getCurrentStepRouter } from 'src/utils/workflow';
import { DirtyMonitor } from './components/shared/dirty-data';
import ClinicInformation from './components/ClinicInformation';

export interface StateFromProps {
  workflow: Workflow;
}

export interface DispatchFromProps {
}

export type OwnProps = RouteComponentProps<{}>;

type Props = StateFromProps & DispatchFromProps & OwnProps;

class App extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);

    const currentStep = getCurrentStepRouter(props.workflow, props.location.pathname);
    props.history.push(currentStep);
  }

  public render() {
    const { workflow, location } = this.props;
    const currentStep = getCurrentStepRouter(workflow, location.pathname);
    const shoudHideMenu: boolean = this.props.location.pathname.includes('/registration/completewithfailallowedretry') || this.props.location.pathname.includes('/registration/completewithpermanentfail');
    return (
      <div className="h-100">
        <div className="main-wrap">
          <nav className="navbar top-bar navbar-expand-lg navbar-light steps">
            <div className="header-top">
              <Header />
            </div>
            {
              shoudHideMenu ? <React.Fragment /> :
                <>
                  <div className="page-title">{`Home > Registration`}</div>
                  {/* <p className="caution-text">Caution: If you already have registered an account with us; however, for some reasons you want to register again such as buy our product for a new address or your account already terminated and you want to register again with us. Please log in to your account and it will take you to your account page or contact us.</p> */}
                  <MainMenu />
                </>
            }
          </nav>

          <Route exact={true} path="/" render={() => <Redirect to={currentStep ? currentStep : `/registration`} />} />
          <Route exact={true} path="/registration" render={() => <Redirect to={currentStep ? currentStep : `/registration/provider`} />} />
          <Route path="/registration/provider" component={Provider} />
          <Route path="/registration/experian" component={Experian} />
          <Route path="/registration/clinic" component={ClinicInformation} />
          <Route path="/registration/agreement" component={ContractAgreement} />
          <Route path="/registration/payment" component={Payment} />
          {/* <Route path="/registration/attachment" component={Attachment} /> */}
          <Route path="/registration/summary" component={Summary} />

          {/* Can not pass experian questions */}
          <Route path="/registration/completewithfailallowedretry" component={CompleteWithFailAllowedRetry} />
          <Route path="/registration/completewithpermanentfail" component={CompleteWithPermanentFail} />
          <Route path="/registration/existuser" component={Error_UserExist} />
        </div>
        <DirtyMonitor />
        <Indicator />
      </div>
    );
  }
}

const mapStateToProps = (rootState: RootState): StateFromProps => ({
  workflow: WorkflowSelector.getWorkflow(rootState)
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): DispatchFromProps => ({
});

export default withRouter(connect<StateFromProps, DispatchFromProps, OwnProps>(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.tsx